import { render, staticRenderFns } from "./SingleSummary.vue?vue&type=template&id=5746a45a&scoped=true&"
import script from "./SingleSummary.vue?vue&type=script&lang=js&"
export * from "./SingleSummary.vue?vue&type=script&lang=js&"
import style0 from "./SingleSummary.vue?vue&type=style&index=0&id=5746a45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5746a45a",
  null
  
)

export default component.exports